import React from "react";

import { ATTACHMENTS_LIMIT_COUNT } from "../../Tasks/common";
import TaskAttachment from "../../Tasks/TaskDetails/Components/TaskAttachments/TaskAttachment";
import { MenuOption } from "@src/sharedComponents/Menu/MenuOption";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "../../Tasks/CreateTask/CreateTask.module.css";

interface AttachmentsSectionProps {
  files: File[];
  onCreateMenuOptions: (fileName: string) => MenuOption[];
}

const AttachmentsSection: React.FC<AttachmentsSectionProps> = ({
  files,
  onCreateMenuOptions,
}) => {
  if (files.length === 0) {
    return null;
  }

  return (
    <div className={styles.attachmentsContainer}>
      <div className={styles.attachmentsHeader}>
        <Text variant="title3">Attachments</Text>
        <Text variant="body" color="textSubtle">
          {files.length}/{ATTACHMENTS_LIMIT_COUNT}
        </Text>
      </div>

      <div className={styles.attachments}>
        {files.map((file) => (
          <TaskAttachment
            key={file.name}
            previewUrl={URL.createObjectURL(file)}
            filename={file.name}
            menuOptions={onCreateMenuOptions(file.name)}
          />
        ))}
      </div>
    </div>
  );
};

export default AttachmentsSection;
